import { transformCurrency } from '@catalyze/ui';

export const edmRangeTextTransformFunctor =
    (min?: number, max?: number) =>
    (lowerBound: string, upperBound: string) => {
        if (min !== undefined && Number(lowerBound) === min) {
            return `Up to ${upperBound} EDMs`;
        } else if (max !== undefined && Number(upperBound) === max) {
            return `At least ${lowerBound} EDMs`;
        }
        return `EDMs count ${lowerBound} - ${upperBound}`;
    };

export const priceRangeTextTransformFunctor =
    (min?: number, max?: number) =>
    (lowerBound: string, upperBound: string) => {
        if (min !== undefined && Number(lowerBound) === min) {
            return `Up to ${transformCurrency(upperBound, 0)}`;
        } else if (max !== undefined && Number(upperBound) === max) {
            return `At least ${transformCurrency(lowerBound, 0)}`;
        }
        return `${transformCurrency(lowerBound, 0)} - ${transformCurrency(
            upperBound,
            0
        )}`;
    };
